import React from 'react';
import { FF_APP_GOOGLE_CALENDAR_INTEGRATION } from '@/shared/utils/feature-flag';
import { GoogleCalendarPane } from './GoogleCalendarPane';

export interface CalendarSettingsGoogleSectionProps {
  agencyId: string;
  currentUserEmail: string;
  calendars: Parameters<typeof GoogleCalendarPane>[0]['calendars'];
}

/**
 * Renders Google Calendar connect UI when the integration feature flag is on.
 */
export const CalendarSettingsGoogleSection: React.FC<
  CalendarSettingsGoogleSectionProps
> = ({ agencyId, currentUserEmail, calendars }) => {
  if (!FF_APP_GOOGLE_CALENDAR_INTEGRATION) {
    return null;
  }
  return (
    <GoogleCalendarPane
      agencyId={agencyId}
      currentUserEmail={currentUserEmail}
      calendars={calendars}
    />
  );
};
